export default __webpack_public_path__ + "static/media/close-icon.97a2302e.svg";